import { Label, Legend } from '@piggybank/form';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import T from 'prop-types';
import React from 'react';
import { DynamicFormTooltip } from './DynamicFormTooltip';
import { MarkdownTranslation } from './Markdown';
import { Optional, TranslationScope } from './context';
import { formNameFromKeyPath, localizationKeyPath, requiredArg } from './utils';

export const DynamicFormLabel = ({
  context = requiredArg('context'),
  formValues = {},
  isFieldset = false,
}) => {
  const { group, keyPath } = context;
  const sanitizedKeyPath = localizationKeyPath(keyPath);
  const currentFormValuePath = formNameFromKeyPath(keyPath).join('.');
  const LabelOrLegend = !isFieldset ? Label : Legend;
  const groupIndex = isNumber(get(group, 'index')) ? group.index + 1 : '';

  return (
    <TranslationScope path={sanitizedKeyPath}>
      <LabelOrLegend>
        <MarkdownTranslation
          {...(!isEmpty(groupIndex) ? { ariaSuffixLabel: groupIndex } : {})}
          currentFormValuePath={currentFormValuePath}
          formValues={formValues}
          noBottomMargin={true}
          path="label"
        />
        <Optional>
          <DynamicFormTooltip formValues={formValues} path={sanitizedKeyPath} />
        </Optional>
      </LabelOrLegend>
    </TranslationScope>
  );
};

DynamicFormLabel.propTypes = {
  context: T.shape({
    group: T.object,
    keyPath: T.object,
    schemaPath: T.arrayOf(T.oneOfType([T.string, T.number])),
  }),
  formValues: T.object,
  isFieldset: T.bool,
};
